import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiBreadcrumbSectionDTO,
  BreadcrumbSectionDTO,
} from "@lib/strapi/dtos/components/sections/breadcrumbSection.dto";
import { LinkService } from "@lib/strapi/services/components/shared/link.service";

export class BreadcrumbSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiBreadcrumbSectionDTO,
  ): Promise<BreadcrumbSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new BreadcrumbSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.style = strapiData.style;
    dto.links = await Promise.all(
      (strapiData.links ?? []).map(
        async (item) => await LinkService.fromStrapi(locale, item),
      ),
    );
    dto.currentPageTitle = strapiData.currentPageTitle;
    dto.hideShareFunctionality = strapiData.hideShareFunctionality;
    return dto;
  }
}
